import React from 'react';
import { Form, FormGroup, Col, Row, Button, InputGroup, FormControl, ControlLabel, Checkbox, Label } from 'react-bootstrap';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Select from 'react-select';
import './style.scss';
import FontAwesome from 'react-fontawesome';
import { export2Excel, filterNumber, getFilteredData, setDataForExpansion, getSum, getBoolColumn, removeRow, getTextColumn } from '../../gridHelpers/gridHelpers';
import _ from 'underscore';
import * as ReactDOM from "react-dom";
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';





class OrderTexts extends React.Component {
    constructor(props) {
        super(props);        
        this.state={data:props.data, changedProdCodes:[], currentExpand:'',expanded: {}, page: 0,
        pageSize: 100, resized:[], selected:-1};
        this.getcolumns=this.getcolumns.bind(this);
        this.renderEditable=this.renderEditable.bind(this);
        //console.log('OrderTexts props:',props);
    }

    reactTable = null;

    // componentDidMount() {
    //   let theads = ReactDOM.findDOMNode(this.reactTable).getElementsByClassName("rt-thead");
    //   let tbody = ReactDOM.findDOMNode(this.reactTable).getElementsByClassName("rt-tbody")[0];
  
  
    //   tbody.addEventListener("scroll", () => {
    //     for (let i = 0; i < theads.length; i++) {
    //       theads.item(i).scrollLeft = tbody.scrollLeft;
    //     }
    //   });
    // }
  
    // componentDidUpdate()  {
    //   let theads = ReactDOM.findDOMNode(this.reactTable).getElementsByClassName("rt-thead");
    //   let tbody = ReactDOM.findDOMNode(this.reactTable).getElementsByClassName("rt-tbody")[0];
  
  
    //   if (tbody.scrollHeight > tbody.clientHeight) {
    //     for (let i = 0; i < theads.length; i++) {
    //       theads.item(i).classList.add("vertical-scrollbar-present");
    //     }
    //   }
    //   else {
    //     for (let i = 0; i < theads.length; i++) {
    //       theads.item(i).classList.remove("vertical-scrollbar-present");
    //     }
    //   }
    // }

    renderEditable(cellInfo) {
      //console.log('this.props.orderTexts[cellInfo.index]',this.props.orderTexts[cellInfo.index]);
      return (

        <div
          style={{ backgroundColor: "#fafafa" }}
          contentEditable={this.props.orderTexts[cellInfo.index].USERDEFINED=='1'|| (this.props.orderTexts[cellInfo.index].IS_EDITABLE)}
          suppressContentEditableWarning
          onBlur={e => {
            if (this.props.orderTexts[cellInfo.index].USERDEFINED=='1' || (this.props.orderTexts[cellInfo.index].IS_EDITABLE))
            {
              const data = [...this.props.orderTexts];
              data[cellInfo.index][cellInfo.column.id] = e.target.innerText;
              this.setState({ });
            }
          }}
          // innerText={ this.props.orderTexts[cellInfo.index][cellInfo.column.id]}
          dangerouslySetInnerHTML={{
            __html: this.props.orderTexts[cellInfo.index][cellInfo.column.id]
          }}
        />
        // <textarea
        //   style={{ backgroundColor: "#fafafa"}}
        //   disabled={this.props.orderTexts[cellInfo.index].USERDEFINED!='1'|| (this.props.orderTexts[cellInfo.index].IS_EDITABLE)==false}

        //   //suppressContentEditableWarning
        //   // onBlur={e => {
        //   //   if (this.props.orderTexts[cellInfo.index].USERDEFINED=='1' || (this.props.orderTexts[cellInfo.index].IS_EDITABLE)==true)
        //   //   {
        //   //     const data = [...this.props.orderTexts];
        //   //     data[cellInfo.index][cellInfo.column.id] = e.target.innerText;
        //   //     this.setState({ });
        //   //   }
        //   // }}
        //   // dangerouslySetInnerHTML={{
        //   //   __html: this.props.orderTexts[cellInfo.index][cellInfo.column.id]
        //   // }}

        //     onBlur={e => {
        //     if (this.props.orderTexts[cellInfo.index].USERDEFINED=='1' || (this.props.orderTexts[cellInfo.index].IS_EDITABLE)==true)
        //     {
        //       const data = [...this.props.orderTexts];
        //       data[cellInfo.index][cellInfo.column.id] = e.target.value;
        //       this.setState({ });
        //     }
        //   }}

        // >{[...this.props.orderTexts][cellInfo.index][cellInfo.column.id]}</textarea>
      );
    }
  
    getFirstFreeUserDefined(data)
    {
      let test=_.sortBy(data.filter(d=>d.TEXT_CODE.indexOf('TCUST'==0)),'TEXT_CODE');
      for(let i=1;i<99;i++)
      {
        let tag='TCUST'+(i.toString().padStart(2,'0'));
        let exists=data.find(d=>d.TEXT_CODE===tag);
        if (exists==undefined)
        {
          return  tag;
        }
      }
      return undefined;
    }

    addNewRow(self)
    {
      let data=self.props.orderTexts;
      let nextTEXT_CODE=this.getFirstFreeUserDefined(data);
      if (nextTEXT_CODE)
      {
        data.push({CLIENT_CODE_REGIONAL:'',DESTINATION_SPECIFIED:'0',
        FOR_DETAIL:self.state.isDetail, FOR_HEADER:self.state.isHeader,IS_EDITABLE:1, SORT_INDEX:null,SELECTED:1,
        IS_VISIBLE:1, TEXT_CODE:nextTEXT_CODE, TEXT_CONTEXT:'',TEXT_TYPE:'0', USERDEFINED:1
         });
        this.setState({});
      }
    }

    getBool(row, prop)
    {
      return row.original[prop]==true;
    }

    getcolumns() {    
      return [ 
        {
          Header: props =><FontAwesome className="handy" name="plus" onClick={() => {this.props.disabled === false && this.addNewRow(this)}}/>, 
          maxWidth: 30,
          filterable: false,
          sortable: false,
          id:'addRemoveRow',
          resizable:false,
          show: hasGrant(Grants.TYPES.Order_ModifyOrderTexts),
          Cell: (props, row) =>{
            let style=props.row._original.TEXT_CODE.indexOf('TCUST')>-1 ? {display:'block'} : {display:'none'};
            return(<span style={style}>
              <FontAwesome className="handy"  name="minus" onClick={
                () => { removeRow(this.props.orderTexts, props.row._original, this, undefined, 'Remove order text','Do you really want to remove this order text?')}}/></span>)
          }
        },
        {
          Header: 'Select',
          maxWidth:60,
          id:'select',
          Cell:  (props, row) =>{ 
            let style=props.row._original.TEXT_CODE.indexOf('TCUST')>-1 ? {display:'none'} : {display:'block'}; 
            return(<span style={style}>
              <input disabled={this.props.disabled} type="checkbox" onChange={ (e)=>{
                props.row._original.SELECTED=e.target.checked;
                this.setState({});
              }}
              checked={props.row._original.SELECTED==true} >
              </input>
            </span>
          )}
        },
        {
          Header: "Code",
          accessor: "TEXT_CODE",
          maxWidth:80
          //Cell: this.renderEditable
        }, 
        {
          Header: "Text",
          maxWidth:1000,
          minWidth:600,   
          Cell:  (props, row) => {
            return (
            <input type="text" className="form-control input-sm"
              disabled={(props.row._original.TEXT_CODE.indexOf('TCUST')==-1 && !props.row._original.IS_EDITABLE) || this.props.disabled }
              onChange={ (e)=>{
              props.row._original["TEXT_CONTEXT"]=e.target.value; 
              this.setState({});
            } }            
            value={ props.row._original["TEXT_CONTEXT"]!==null ?  props.row._original["TEXT_CONTEXT"] : ''} ></input>
          )}
        },
        {
          Header:'Sort index',
          accessor:'SORT_INDEX'
        } 

      ];
    }
    render()
    {
        let data = this.props.orderTexts.filter(t=>t.IS_VISIBLE); 
//        console.log('OrderTexts.data',data);
        return ( 
          <div> 
            <Dialog ref={(el) => { this.dialog = el }} />          
            <NPReactTable
            // getTbodyProps={ (state, rowInfo, column, rtInstance) => { return { style: { overflowY: 'scroll' } } } }
            // getTrProps={(state, rowInfo, column) => {
            //   //console.log('state',state, 'rowinfo',rowInfo, 'column',column);
            //   return (rowInfo && rowInfo.original && rowInfo.original.ToBeDeleted)
            //   ? {
                  
            //       style: {
            //         backgroundColor: '#FFFAD0'
            //         }
            //     }
            //   :{}
            // }}
              className="margin-top-5 np-react-table"
              data={data}   
              //style={{ height: '200px'}}  
              //height={"200px"}
              //getTbodyProps={ (state, rowInfo, column, rtInstance) => { return { style: { overflowY: 'scroll' } } } }
              ref={(r) => { this.reactTable = r }}
              showPagination={false}
              showPageSizeOptions={false}
              minRows={5}
              showPageJump={false}  
              columns={this.getcolumns()}
              //defaultPageSize={5}
              // Controlled props
              //sorted={this.state.sorted}
              //page={this.state.page}
              //pageSize={this.state.pageSize}
              expanded={this.state.expanded}
              resized={this.state.resized}  
              onResizedChange={resized => { this.setState({ resized }) } }
            />
        </div>
        );
    } 
}

export default OrderTexts;